import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { hideScrollbar } from '@sorare/core/src/style/utils';

import { DivisionIcon } from 'components/rivals/seasons/divisionPicker/DivisionIcon';

import { ScrollableDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig } from './__generated__/index.graphql';

const Root = styled(Horizontal).attrs({ gap: 2 })`
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  ${hideScrollbar}

  & > * {
    scroll-snap-align: center;
  }
`;

type Props = {
  divisionConfigs: ScrollableDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig[];
  onClick: (
    division: ScrollableDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig
  ) => void;
  selectedDivision?: ScrollableDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig;
  biggerSelected?: boolean;
};

export const ScrollableDivisionPicker = ({
  divisionConfigs,
  onClick,
  selectedDivision,
  biggerSelected,
}: Props) => {
  return (
    <Root>
      {divisionConfigs.map(division => {
        const { id, badgeUrl, title } = division;
        const selected = id === selectedDivision?.id;
        return (
          <ButtonBase
            key={title}
            onClick={() => {
              onClick(division);
            }}
          >
            <DivisionIcon
              badgeUrl={badgeUrl}
              selected={selected}
              title={title}
              width={selected && biggerSelected ? 48 : 32}
            />
          </ButtonBase>
        );
      })}
    </Root>
  );
};

ScrollableDivisionPicker.fragments = {
  footballRivalsDivisionLeaderboardDivisionConfig: gql`
    fragment ScrollableDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig on FootballRivalsDivisionLeaderboardDivisionConfig {
      id
      badgeUrl
      title
    }
  ` as TypedDocumentNode<ScrollableDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig>,
};
